import React from "react";
import Style from "./style.module.css";
import { FeildError, FeildWraper, FormArea, FormCheckbox, FormHeading1, FormLabel } from "../../../component/form/form-layout";


const Step3Form = ({ formik }) => {
    const flagsData = [
        {
            key: "wrongSale",
            label: "Wrong Sale",
            options: [
                "Promised unsupported feature",
                "Incorrect product match",
                "Fake urgency / misleading",
                "None of Them",
            ],
            noteKey: "wrongSale_note",
        },
        {
            key: "trainingNeeded",
            label: "Training Needed",
            options: [
                "Product knowledge",
                "Soft skills",
                "Compliance",
                "Upsell skills",
                "None of Them",
            ],
            noteKey: "trainingNeeded_note",
        },
        {
            key: "refundTrigger",
            label: "Refund Trigger",
            options: [
                "Client sounded unhappy",
                "Dispute warning signs",
                "False commitment",
                "None of Them",
            ],
            noteKey: "refundTrigger_note",
        },
        {
            key: "missedOpportunity",
            label: "Missed Opportunity",
            options: [
                "Didn't upsell",
                "Missed renewal",
                "Didn't cross-sell",
                "None of Them",
            ],
            noteKey: "missedOpportunity_note",
        },
        {
            key: "productionMisalignment",
            label: "Production Misalignment",
            options: [
                "Overpromised",
                "Miscommunication with production",
                "None of Them",
            ],
            noteKey: "productionMisalignment_note",
        },
    ];

    return (
        <FormArea>
            {
                flagsData.map((flag, fIdx) => (


                    <React.Fragment key={flag.key}>
                        <FormHeading1>{flag.label}</FormHeading1>

                        {flag.options.map((opt) => (
                            <FeildWraper key={flag.key + "_" + opt}>
                                <FormCheckbox
                                    label={opt}
                                    name={`flags.${flag.key}.${opt}`}
                                    value={opt}
                                    checked={formik.values.flags[flag.key]?.includes(opt)}
                                    disabled={
                                        opt !== "None of Them"
                                            ? formik.values.flags[flag.key]?.includes("None of Them")
                                            : false
                                    }
                                    onChange={(e) => {
                                        let arr = [...(formik.values.flags[flag.key] || [])];

                                        if (opt === "None of Them") {
                                            arr = e.target.checked ? ["None of Them"] : [];
                                        } else {
                                            arr = arr.filter((v) => v !== "None of Them");
                                            if (e.target.checked) arr.push(opt);
                                            else arr = arr.filter((v) => v !== opt);
                                        }

                                        formik.setFieldValue(`flags.${flag.key}`, arr);
                                    }}
                                />
                            </FeildWraper>
                        ))}

                        {formik.touched?.flags?.[flag.key] &&
                            !formik.values.flags?.[flag.key]?.length &&
                            !formik.values.flags?.[`${flag.key}_note`]?.trim() && (
                                <FeildWraper>
                                    <FeildError>
                                        Select at least one option or add a note
                                    </FeildError>
                                </FeildWraper>
                            )}


                        <FeildWraper width="100%">
                            <textarea
                                className={Style.textarea} // tumhare css class
                                placeholder="Add notes..."
                                value={formik.values.flags[flag.noteKey] || ""}
                                onChange={(e) =>
                                    formik.setFieldValue(`flags.${flag.noteKey}`, e.target.value)
                                }
                            />
                        </FeildWraper>
                    </React.Fragment>

                ))
            }
        </FormArea>
    );
};

export default Step3Form;
